import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { SupportComment } from './support-comment';
export { SupportComment };
import { supportCommentSchema } from '@schemas/business-objects/support-comment';
import { AccountFormGroup } from './account-form-group';
import { SupportAttachmentFormArray } from './support-attachment-form-group';
import { SupportCaseFormGroup } from './support-case-form-group';
import { UserFormGroup } from './user-form-group';

export class SupportCommentFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    body: SchemaFormControl;
    isSystem: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    caseId: SchemaFormControl;
    case: SupportCaseFormGroup;
    accountId: SchemaFormControl;
    account: AccountFormGroup;
    attachments: SupportAttachmentFormArray;
    createdById: SchemaFormControl;
    createdBy: UserFormGroup;
    updatedById: SchemaFormControl;
    updatedBy: UserFormGroup;
  };

  declare value: Partial<SupportComment>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(supportCommentSchema, SupportComment, data, options);
  }

  get object(): SupportComment {
    return new SupportComment(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'case':
        return new SupportCaseFormGroup();
      case 'account':
        return new AccountFormGroup();
      case 'attachments':
        return new SupportAttachmentFormArray();
      case 'createdBy':
        return new UserFormGroup();
      case 'updatedBy':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<SupportComment[]> {
    return SupportComment.find(filter);
  }

  static async findOne(filter?: any): Promise<SupportComment | null> {
    return SupportComment.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<SupportComment> {
    return SupportComment.findById(id, filter);
  }

  static async create(data: Partial<SupportComment>): Promise<SupportComment> {
    return SupportComment.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<SupportComment>,
  ): Promise<SupportComment> {
    return SupportComment.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return SupportComment.deleteById(id);
  }
}

export class SupportCommentFormArray extends PersistedFormArray {
  declare controls: SupportCommentFormGroup[];

  readonly entityName = 'SupportComment' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(supportCommentSchema, SupportComment, options);
  }

  protected override createItemGroup() {
    return new SupportCommentFormGroup();
  }

  get array(): SupportComment[] {
    return this.controls.map((group: SupportCommentFormGroup) => group.object);
  }
}

export class SupportCommentPersistedArray extends PersistedArray<SupportComment> {
  readonly entityName = 'SupportComment' as const;

  constructor(options?: PersistedArrayOptions) {
    super(SupportComment, options);
  }
}
